// ISO 3166-1 alpha-2 codes for countries we treat as "inside Europe" for privacy purposes.
// This is broadly the European Economic Area **plus** all EFTA members **plus** the United Kingdom.
// • EU member states (27)
// • EEA–EFTA: IS (Iceland), LI (Liechtenstein), NO (Norway)
// • CH (Switzerland) – EFTA but *not* part of the EEA, kept here for consistency with the comment.
// Note: "UK" is not an official ISO code; we use "GB".
export const EEA = [
	"AT", // Austria
	"BE", // Belgium
	"BG", // Bulgaria
	"HR", // Croatia
	"CY", // Cyprus
	"CZ", // Czech Republic
	"DK", // Denmark
	"EE", // Estonia
	"FI", // Finland
	"FR", // France
	"DE", // Germany
	"GR", // Greece
	"HU", // Hungary
	"IS", // Iceland
	"IE", // Ireland
	"IT", // Italy
	"LI", // Liechtenstein
	"LV", // Latvia
	"LT", // Lithuania
	"LU", // Luxembourg
	"MT", // Malta
	"NL", // Netherlands
	"NO", // Norway
	"PL", // Poland
	"PT", // Portugal
	"RO", // Romania
	"SK", // Slovakia
	"SI", // Slovenia
	"ES", // Spain
	"SE", // Sweden
	"GB", // United Kingdom
	"CH", // Switzerland
	"EU", // European Union
];
